import React from "react"
import { StyledTranslate } from "./partials"

export interface TranslateProps {
  translate: boolean
}

export const TranslateCmp: React.FC<TranslateProps> = ({ translate }) => (
  <StyledTranslate>
    {translate === true ? <p>its on</p> : <p>its off</p> }
  </StyledTranslate>
)